import Sigma from 'expf-sigma.js';

// Токен для подключения к Sigma лучше не выносить в отдельный файл, чтобы не было соблазна его переиспользовать
const TOKEN =
  process.env.SIGMA_PROJECT_TOKEN || '9AC6CE27-19AA-493C-9EB6-179FE9BE6AC1';
// URL для подключения к сигме
const API = process.env.SIGMA_SERVER_URL || 'https://api.expf.ru/api/v1';

/**
 * Функция инициализации нового сплитовщика в нашем проекта под названием Sigma
 * Вынесен в отдельный файл чтобы импортировать его через lazy так как импорт данного модуля сразу разламывает SSR
 * @see https://docs.expf.ru/ - ссылка на документацию
 */
export const sigmaInit = async (userId: string) => {
  const sigma = new Sigma();
  const userData = {
    userId,
  };
  sigma.init({ token: TOKEN, userData, api: API });
  return sigma;
};
